import React, { Component } from "react";
import SalaryChange from "../../../components/SalaryChange/SalaryChange";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : EmployesForm
Description : Compoente que alberga el resto del formulario de Employes definido en el directorio de componentes
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente de Employes
================================================================================ */

class SalaryChangeForm extends Component {
    render() {
        return (
            <SalaryChange />
        )
    }
}

export default SalaryChangeForm;